/* eslint-disable react-hooks/exhaustive-deps */
import React,{FC, useEffect, useState} from "react";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getListEconomies } from "../core/_request";
import { getISO2ByISO3, getNameByISO3 } from '../../../../libs/misc'
import { ASEAN_MEMBER } from "../../../../libs/constant";

type TradePartnerDropdownProps = {
  onSelect: (econ:any) => void;
  defaultEcon?: string;
  role?:string;
}

const TradePartnerDropdown:FC<TradePartnerDropdownProps> = ({
  onSelect,
  defaultEcon,
  role = 'rep'
}) => {
  const [economies, setEconomies] = useState<Array<any> | null>([])
  const [selectedEcon, setSelectedEcon] = useState<string>(''); 

  useEffect(()=>{
    getListEconomies()
      .then(res=>{
        const econs = res.data
        const econISO3List = econs.map((econ:any)=>econ.iso3)
        if(role==='rep'){
          setEconomies([
            'ASEAN',
            ...ASEAN_MEMBER
          ])
        }else if(role==='par'){
          setEconomies([
            'WLD',
            ...econISO3List
          ])
        }
        setSelectedEcon(defaultEcon || 'WLD')
        onSelect(defaultEcon || 'WLD')
      })
      .catch(e=>{
        console.error(e)
      })
  },[])

  const handleSelect = (econ:any) => { 
    onSelect(econ);
    setSelectedEcon(econ)
  }

  const dropdownItem = economies?.map((econ)=>{
    const iso2 = getISO2ByISO3(econ) || ''
    let flagIcon = (<i className="fa-solid fa-globe me-2"></i>);
    if(iso2) {
      flagIcon =  (<span className={`fi fi-${iso2?.toLowerCase()} me-2`}></span>)
    }else if(econ==='ASEAN'){
      flagIcon = (<span className='me-2'>
        <img
          src="/media/flags/asean.png"
          alt="ASEAN Flag"
          width="20"
          height="14"
          style={{ verticalAlign: 'middle' }}
        />
      </span>)
    }
    return (
      <OverlayTrigger 
        key={econ.toLowerCase()} 
        placement="left" 
        overlay={<Tooltip id={`tooltip-${iso2}`}>{getNameByISO3(econ)}</Tooltip>} > 
        <Dropdown.Item role="menuitem" size="sm" onClick={()=>handleSelect(econ)}> 
          {flagIcon}
          {getNameByISO3(econ)} 
        </Dropdown.Item> 
      </OverlayTrigger>
    )
  })

  let flagIcon = <i className="fa-solid fa-globe me-2"></i>;
  if(selectedEcon==='ASEAN'){
    flagIcon = (<span className='me-2'>
        <img
          src="/media/flags/asean.png"
          alt="ASEAN Flag"
          width="20"
          height="14"
          style={{ verticalAlign: 'middle' }}
        />
      </span>)
  }else if(getISO2ByISO3(selectedEcon)){
    flagIcon = (<span className={`fi fi-${getISO2ByISO3(selectedEcon)?.toLowerCase()} me-2`}></span>)
  }

  return (    
    <Dropdown className="">
      <Dropdown.Toggle variant="label-dropdown" id="" className="btn btn-sm btn-bold dropdown-toggle fw-normal text-start w-100" style={{
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
      }}>
        {selectedEcon ? 
          ( 
            <div style={{
              whiteSpace: 'nowrap', 
              overflow: 'hidden', 
              textOverflow: 'clip',
              maxWidth:'200px'
            }}> 
              {flagIcon}
              {getNameByISO3(selectedEcon)} 
            </div> 
          ) : ('Loading Trade Partners...')}
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-econ-menu">
        {dropdownItem}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default TradePartnerDropdown